import { t } from 'i18next'

import type { WalletBalanceOriginRow } from '../WalletBalanceOrigin/types'

export const getTransactionOriginLabel = (
  checkingAccountId: string | undefined,
  originById: Map<string, WalletBalanceOriginRow>
): string => {
  if (!checkingAccountId) return '—'
  const origin = originById.get(checkingAccountId)
  if (!origin) return '—'
  if (origin.kind === 'preexisting') {
    return origin.name ?? t('rm:wallet.balanceOrigin.preexisting.name')
  }
  return `${origin.name} · ${origin.id}`
}

export const buildOriginSchemaColumn = (
  originById: Map<string, WalletBalanceOriginRow>
) => ({
  origin: {
    title: t('rm:wallet.movimentations.table.column.title.origin'),
    render: (rowData: CheckingAccountTransaction) =>
      getTransactionOriginLabel(rowData?.checking_account_id, originById)
  }
})
